import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginBrComponent } from './components/login-br/login-br.component';
import { LoginEnComponent } from './components/login-en/login-en.component';

const routes: Routes = [
  { path: '', redirectTo: '/en', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'login/:id', component: LoginComponent },
  { path: 'es', component: LoginComponent },
  { path: 'es/:id', component: LoginComponent },
  { path: 'br', component: LoginBrComponent },
  { path: 'br/:id', component: LoginBrComponent },
  { path: 'en', component: LoginEnComponent },
  { path: 'en/:id', component: LoginEnComponent },
  { path: '**', redirectTo: '/en' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }


